import {cn} from '@/utils';
import React from 'react';

export interface PanelSmallItemProps {
  icon?: React.ReactNode;
  title: string;
  result: string;
  loading?: boolean;
  placement?: 'left' | 'right';
  resultClassName?: string;
}

const PanelSmallItem: React.FC<PanelSmallItemProps> = ({
  icon,
  title,
  result,
  loading = false,
  placement = 'left',
  resultClassName = '',
}) => {
  return (
    <div
      className={`flex flex-col gap-y-1 ${
        placement === 'right' ? 'items-end' : 'items-start'
      }`}>
      <div className="flex flex-row items-center gap-x-1">
        {icon && <div className="w-4 h-4">{icon}</div>}
        <span className="text-xs text-t3 opacity-80">{title}</span>
      </div>
      <div className={cn('text-sm font-bold text-[#F15802]', resultClassName)}>
        {loading ? '-' : result}
      </div>
    </div>
  );
};

export default PanelSmallItem;
